import { Table, TableBody, TableHead, TableRow } from '@mui/material';
import {
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
  ActionIconButton,
  NoDataSkeleton,
} from '../../../common/components';
import { formatAccountType, formatBankName } from '../utils/formatters';

const BankAccountsDataTable = ({
  data,
  isLoading,
  onEdit,
  onDelete,
  LoadingComponent,
}) => {
  if (isLoading) {
    return <LoadingComponent />;
  }

  return (
    <GeneralTableBox>
      <Table stickyHeader size="small">
        <TableHead>
          <TableRow>
            <HeadTableCell>Banco</HeadTableCell>
            <HeadTableCell>N° de cuenta</HeadTableCell>
            <HeadTableCell>Tipo</HeadTableCell>
            <HeadTableCell>CBU</HeadTableCell>
            <HeadTableCell>Alias</HeadTableCell>
            <HeadTableCell>Acciones</HeadTableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {data && data.length > 0 ? (
            data.map((account) => (
              <TableRow key={account.uuid}>
                <RowTableCell>{formatBankName(account.bank_name)}</RowTableCell>
                <RowTableCell>{account.account_number}</RowTableCell>
                <RowTableCell>{formatAccountType(account.account_type)}</RowTableCell>
                <RowTableCell>{account.cbu}</RowTableCell>
                <RowTableCell>{account.alias || '-'}</RowTableCell>
                <RowTableCell>
                  <ActionIconButton variant="edit" onClick={() => onEdit(account)} />
                  <ActionIconButton variant="delete" onClick={() => onDelete(account)} />
                </RowTableCell>
              </TableRow>
            ))
          ) : (
            <NoDataSkeleton message="No se encontraron cuentas bancarias" />
          )}
        </TableBody>
      </Table>
    </GeneralTableBox>
  );
};

export default BankAccountsDataTable;
